const isFactory = (value) => typeof value === "function";
export const delay = (msDelay) => {
    return new Promise((resolve) => setTimeout(() => {
        resolve();
    }, msDelay));
};
export const echo = (value, msDelay) => {
    let timeout;
    const promise = Object.assign(new Promise((resolve) => {
        timeout = setTimeout(() => {
            resolve(isFactory(value) ? value() : value);
        }, msDelay);
    }), {
        clear: () => {
            clearTimeout(timeout);
        },
    });
    return promise;
};
export const microEcho = (value) => {
    return new Promise((resolve) => {
        queueMicrotask(() => {
            resolve(isFactory(value) ? value() : value);
        });
    });
};
//# sourceMappingURL=delay.js.map